import { render, staticRenderFns } from "./express-dialog.vue?vue&type=template&id=7f07d94e&scoped=true&"
import script from "./express-dialog.vue?vue&type=script&lang=js&"
export * from "./express-dialog.vue?vue&type=script&lang=js&"
import style0 from "./express-dialog.vue?vue&type=style&index=0&id=7f07d94e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f07d94e",
  null
  
)

export default component.exports